import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

// components
import { DeliveryHalfCard } from "@swiggy-private/cart-ui";

// types
import { MROChildCart, Option } from "@swiggy-private/cart-types";

// hooks
import { useCartDeliverySpeed } from "@cart-client/hooks/useCartDeliverySpeed";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getSelectedOptionFromWidgetOptions } from "./helpers/mro";

export interface MRODeliverySpeedHalfCardProps {
    cart: MROChildCart;
    isOpen: boolean;
    onClose: VoidFunction;
}

function MRODeliverySpeedHalfCard({ cart, isOpen, onClose }: MRODeliverySpeedHalfCardProps) {
    const {
        deliverySpeedWidgetInfoV2,
        selectedSlaOption,
        onDeliverySpeedItemClick,
        onOptInWidgetClick,
        selectedAddress,
    } = useCartDeliverySpeed({
        cartResponse: cart,
    });

    const selectedSlaFromSlaOptions = useMemo(
        () => getSelectedOptionFromWidgetOptions(deliverySpeedWidgetInfoV2?.options, selectedSlaOption),
        [deliverySpeedWidgetInfoV2?.options, selectedSlaOption],
    );
    const [currentSla, setCurrentSla] = useState<Option | undefined>(selectedSlaFromSlaOptions);
    const { delivery_type_opt_in: deliveryTypeOptIn } = selectedAddress || {};

    useEffect(() => {
        if (isOpen) {
            setCurrentSla(selectedSlaFromSlaOptions);
        }
    }, [isOpen, selectedSlaFromSlaOptions]);

    const setIsHalfCardOpen = useCallback(() => {
        onClose();
    }, [onClose]);

    if (!deliverySpeedWidgetInfoV2 || isEmpty(deliverySpeedWidgetInfoV2?.options)) {
        return null;
    }

    return (
        <DeliveryHalfCard
            cart={cart}
            deliverySpeedWidgetInfoV2={deliverySpeedWidgetInfoV2}
            onDeliverySpeedItemClick={onDeliverySpeedItemClick}
            selectedSlaOption={selectedSlaOption}
            onOptInWidgetClick={onOptInWidgetClick}
            deliveryTypeOptIn={deliveryTypeOptIn}
            currentSla={currentSla}
            setCurrentSla={setCurrentSla}
            isHalfCardOpen={isOpen}
            setIsHalfCardOpen={setIsHalfCardOpen}
        />
    );
}

export default memo(MRODeliverySpeedHalfCard);
